import { GroupFormDialog } from '@wellesley/group'
import { AppsLink } from '@wellesley/router'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@wellesley/ui'
import { useSwitchState } from 'hooks/useSwitchState'

import { Compass, Plus } from 'lucide-react'

const AddGroupButton = () => {
  const [isGroupFormOpen, openGroupForm, closeGroupForm] = useSwitchState(false)

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex w-full cursor-pointer items-center justify-center">
            <div className="flex size-12 items-center justify-center rounded-full bg-slate-100  ">
              <Plus className="text-slate-700" size={24} />
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="min-w-[232px] rounded-lg border-none p-xxs text-sm font-semibold !outline !outline-1 !outline-slate-200"
          align="center"
          side="right"
        >
          <AppsLink to="/discover">
            <DropdownMenuItem className="mb-xxxs flex min-h-10 cursor-pointer items-center gap-xxs px-xs">
              <Compass /> Discover groups
            </DropdownMenuItem>
          </AppsLink>
          <DropdownMenuItem
            onClick={openGroupForm}
            className="flex min-h-10 cursor-pointer items-center gap-xxs px-xs"
          >
            <Plus /> Create new group
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <GroupFormDialog open={isGroupFormOpen} handleCancel={closeGroupForm} />
    </>
  )
}

export default AddGroupButton
